import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { useRequest } from "../../utils";

const showTypes = (props) => {
  const [types_error, types_loading, types_data, types_function, clearData] =
    useRequest({
      method: "get",
      url: "/get_types",
    });
  const [
    delete_type_by_id_error,
    delete_type_by_id_loading,
    delete_type_by_id_data,
    delete_type_by_id_function,
  ] = useRequest({
    method: "post",
    url: "/delete_type_by_id",
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {types_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">عنوان</th>

                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              types_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>
                    <Link to={"/dashboard/editType/" + item._id}>
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                    <button
                      onClick={async () => {
                        await clearData();
                        delete_type_by_id_function({
                          type_id: item._id,
                        })
                          .then(() => {
                            utils.showAlert("با موفقیت حذف شد", "success");
                            types_function();
                          })
                          .catch(() => {
                            utils.showAlert("حذف نشد", "error");
                            types_function();
                          });
                      }}
                      type="button"
                      class="btn btn-danger round mr-1 mb-1 btn-sm"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { showTypes };
